import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { PressService, AttachmentService } from '../../../../phf.service';
import { Subject, BehaviorSubject } from 'rxjs';
import { PartDetailService } from '../part-detail.service';
import { S3Service } from '../../../../../../shared/services/s3.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'press-tab',
  templateUrl: './press-tab.component.html',
  styleUrls: ['../part-detail.component.scss']
})
export class PressTabComponent implements OnInit {
  PressId: any;
  editForm: FormGroup;
  isEditing: boolean;
  isLoading = false;
  atachmentLoading = true;
  imgUrl: BehaviorSubject<string> = new BehaviorSubject<string>("");
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();

  @Input()
  set data(dataItem: any) {
    if (dataItem) {
      this.PressId = dataItem;
    }
  }

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly pressService: PressService,
    public readonly messageService: PartDetailService,
    private readonly attachmentService: AttachmentService,
    private readonly s3Service: S3Service,
  ) {
    this.messageService.getMessage()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(message => {
        this.isEditing = message.editing;
      });
  }

  ngOnInit() {
    this.editForm = this.formBuilder.group(PressEditForm);
    this.isLoading = true;
    this.messageService.pressDataObject = this.editForm; // Sets pointer from messageService Press to this formGroup
    this.refreshInfo();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  refreshInfo() {
    if (this.PressId) {
      this.pressService.read('/' + this.PressId)
        .then(pressResult => {
          if (pressResult) {
            this.editForm.reset(pressResult);
            if (pressResult.AttachmentId) {
              this.attachmentService.read('/' + pressResult.AttachmentId)
                .then(response => {
                  this.updateFilePath(response);
                })
            }
          }
          this.isLoading = false;
        })
    }
    else { this.isLoading = false; }
  }

  private updateFilePath(response) {
    if (response) {
      const filePath = response.Path + '/' + response.FileName;
      const url = this.s3Service.getS3Path(filePath);
      if (url) {
        this.imgUrl.next(url);
        this.editForm.get('Attachment').setValue(url);
      }
      else {
        this.imgUrl.next("");
        this.editForm.get('Attachment').setValue("");
      }
    }
  }

  openImg = () => {
    this.messageService.showZoomInDialog = true;
    this.messageService.zoomInData = {
      title: this.editForm.get('Number'),
      imagePath: this.editForm.get('Attachment')
    };
  }

  getAttachmentId() {
    return this.editForm.get('AttachmentId').value;
  }

  onAttachmentLoad = () => {
    this.atachmentLoading = false;
  }
}

const PressEditForm = {
  PressId: [],
  Id: [],
  PlantName: [],
  Number: [],
  Class: [],
  Type: [],
  TransferType: [],
  FOLType: [],
  EOLType: [],
  TransferNote: [],
  PressNote: [],
  FOLNote: [],
  EOLNote: [],
  RestrictionNote: [],
  TargetSPM: [],
  PressMax: [],
  SystemMax: [],
  TransferMax: [],
  FOLMax: [],
  EOLMax: [],
  HandlingTarget: [],
  TruckTarget: [],
  ObservedEquipmentRestriction: [],
  EquipmentRestriction: [],
  ImageTeamcenterURL: [],
  RoboticLoading: [],
  AvailableAssist: [],
  TotalNumberOfWorkStations: [],
  PlantId: [],
  IsActive: [],
  Attachment: [],
  AttachmentId: [],
  TruckMax: [],
  HandlingMax: [],
  SystemTargetSPM: [],
}
